export default {"src":"/_next/static/media/bacon.8baf9eac.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};